// extracted by mini-css-extract-plugin
module.exports = {"itemContainer":"item_itemContainer__120Fl","itemHeader":"item_itemHeader__3h7D6","itemDescription":"item_itemDescription__2WA7V"};